import { OffersData } from "./OffersData";
import { Pair } from "./Pair";

export class OffersResults {
    cnt: number | null;
    listOfTerms: Pair[] | null;
    listOfSavings: Pair[] | null;
    data: OffersData[]

    constructor(cnt: number, listOfTerms: Pair[], listOfSavings: Pair[], data: OffersData[]) {
        this.cnt=cnt;
        this.listOfTerms = listOfTerms;
        this.listOfSavings = listOfSavings;
        this.data = data;
    }

}